import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/metaPixel";

/**
 * SPA-aware PageView tracker.
 * Place once inside <BrowserRouter> to fire PageView on every route change.
 */
export function useMetaPixelPageView(): void {
  const location = useLocation();

  useEffect(() => {
    trackPageView();
  }, [location.pathname, location.search]);
}
